'use client';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import PlanItems from '../plans/PlanItems';

const PlansSection = () => {
  const muiTheme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridAutoRows: '1fr auto',
          minHeight: '100svh',
        }}>
        <Stack sx={{ alignItems: 'center', justifyContent: 'center', px: 2 }}>
          <Typography
            sx={{
              fontSize: { xs: 28, sm: 36, md: 42 },
              fontWeight: 500,
              color: 'common.white',
              textAlign: 'center',
            }}>
            پلن مورد نظر خودت{' '}
            <span style={{ color: muiTheme.palette.primary.main }}>انتخاب</span>{' '}
            کن{' '}
          </Typography>
          <Typography
            sx={{ textAlign: 'center', color: 'common.white' }}
            fontSize={{ xs: 18, sm: 20, md: 22 }}
            pt={1}>
            متناسب با نیاز خود از خدمات ما استفاده کنید
          </Typography>
        </Stack>
        <Box sx={{ px: 2, mt: 5 }}>
          <PlanItems showGifts={true} />
        </Box>
      </Box>
    </>
  );
};

export default PlansSection;
